export default "__VITE_ASSET__C0zX42fV__"